import axiosClient from '../interceptors';
import {ApiRoutes} from "../routes/ApiRoutes";
import {getAPIUrl} from "./BaseService";
import {School, SchoolSettings, Subject} from "../types";

export interface SubjectSuggestion {
    name: string;
    code?: string | null;
}

export interface UpdateSchoolProfilePayload {
    name?: string;
    address?: string;
    email?: string;
    phone_no?: string;
    logo?: string | null;
}

export async function getSchoolSubjects(): Promise<Subject[]> {
    const url = getAPIUrl() + ApiRoutes.SUBJECTS;
    const response = await axiosClient.get<Subject[]>(url);
    return response.data;
}

export async function getSubjectSuggestions(q?: string, limit: number = 100): Promise<SubjectSuggestion[]> {
    const url = getAPIUrl() + ApiRoutes.SUBJECT_SUGGESTIONS;
    const response = await axiosClient.get<SubjectSuggestion[]>(url, {
        params: {
            q: q || undefined,
            limit,
        },
    });
    return response.data;
}

export async function updateSchoolSettings(schoolId: string, settings: Partial<SchoolSettings>): Promise<School> {
    const url = `${getAPIUrl()}${ApiRoutes.SCHOOLS}/${schoolId}/settings`;
    const response = await axiosClient.patch<School>(url, { settings });
    return response.data;
}

export async function getSchoolById(schoolId: string): Promise<School> {
    const url = `${getAPIUrl()}${ApiRoutes.SCHOOLS}/${schoolId}`;
    const response = await axiosClient.get<School>(url);
    return response.data;
}

export async function updateSchoolProfile(schoolId: string, payload: UpdateSchoolProfilePayload): Promise<School> {
    const url = `${getAPIUrl()}${ApiRoutes.SCHOOLS}/${schoolId}`;
    const response = await axiosClient.patch<School>(url, payload);
    return response.data;
}

export interface SchoolGradingDefaults {
    default_rubric_id: string | null;
    default_grade_scheme_id: string | null;
}

export async function getSchoolGradingDefaults(schoolId: string): Promise<SchoolGradingDefaults> {
    const url = `${getAPIUrl()}${ApiRoutes.SCHOOLS}/${schoolId}/grading-defaults`;
    const response = await axiosClient.get<SchoolGradingDefaults>(url);
    return response.data;
}

export async function updateSchoolGradingDefaults(
    schoolId: string,
    payload: Partial<SchoolGradingDefaults>,
): Promise<School> {
    const url = `${getAPIUrl()}${ApiRoutes.SCHOOLS}/${schoolId}/grading-defaults`;
    const response = await axiosClient.patch<School>(url, payload);
    return response.data;
}

export interface SchoolReportDefaults {
    default_report_template_id: string | null;
}

export async function getSchoolReportDefaults(schoolId: string): Promise<SchoolReportDefaults> {
    const url = `${getAPIUrl()}${ApiRoutes.SCHOOLS}/${schoolId}/report-defaults`;
    const response = await axiosClient.get<SchoolReportDefaults>(url);
    return response.data;
}

export async function updateSchoolReportDefaults(
    schoolId: string,
    payload: Partial<SchoolReportDefaults>,
): Promise<School> {
    const url = `${getAPIUrl()}${ApiRoutes.SCHOOLS}/${schoolId}/report-defaults`;
    const response = await axiosClient.patch<School>(url, payload);
    return response.data;
}
